export default __webpack_public_path__ + "static/media/PayPal.29d94f7f.png";